<button [uiType]="uiType" [disabled]="uiDisabled" (click)="buttonClick.next()" ui-button uiShape="round">
  {{ uiButtonText }}
</button>
<button
  [uiDropdownMenu]="menu"
  [uiType]="uiType"
  [disabled]="uiDisabled"
  [a11yTitle]="'Button.openDropdown' | uiI18n"
  [uiBackdrop]="true"
  ui-button
  uiShape="round"
  uiTrigger="click"
  ui-dropdown
  uiPlacement="bottomRight">
  <i uiType="chevron-down-small" ui-icon></i>
</button>

<ui-dropdown-menu #menu="uiDropdownMenu">
  <ng-content></ng-content>
</ui-dropdown-menu>
